import React, { useEffect } from "react";
import { loadModules } from "esri-loader";
import './ServiceTable.css';

const FeatureTableComponent = () => {
  useEffect(() => {
    loadModules(
      ["esri/layers/FeatureLayer", "esri/widgets/FeatureTable","esri/layers/GeoJSONLayer"],
      { css: true }
    ).then(([FeatureLayer, FeatureTable,GeoJSONLayer]) => {
      const featureLayer = new FeatureLayer({
        url: "https://services2.arcgis.com/PVecJWbX0qVr6qCM/arcgis/rest/services/companies_data_updated/FeatureServer",
        title: "Companies",
      });


    //   const featureLayer = new GeoJSONLayer({
    //     url: " https://gladtofindu-back-nodejs-companies.onrender.com/featurelayers",
    //     title: "Companies",
    //   });


      const featureTable = new FeatureTable({
        layer: featureLayer,
        multiSortEnabled: true,
        visibleElements: { selectionColumn: false },
        tableTemplate: {
            search: true, // Ajouter la barre de recherche
            showSelectedRows: true, // Ne pas afficher les lignes sélectionnées
          columnTemplates: [
            {
              type: "field",    
              fieldName: "creationDate",
              label: "Creation Date",
              visible: true,
              format: {
                dateFormat: "short-date"
              }
            },
            {
                type: "field",
                fieldName: "mainActivityCode",
                label: "Main activity code",
              },
              {
                type: "field",
                fieldName: "mainActivityName",
                label: "Main activity name",
              },
            {
                type: "field",
                fieldName: "name",
                label: "Name",
                visible: true,
              },
            {   
              type: "field",
              fieldName: "address",
              label: "Adress",
            //   direction: "asc",
            //   initialSortPriority: 1,
            },
            {
              type: "field",
              fieldName: "postCode",
              label: "Post code",
            //   direction: "asc",
            //   initialSortPriority: 0,
            },
            {
              type: "field",
              fieldName: "siretNumber",
              label: "Siret number",
            },
            {
              type: "field",
              fieldName: "date_cloture_exercice",
              label: "Accounts closing date",
              visible: true,
              format: {
                dateFormat: "short-date"
              }
            },
            {
              type: "field",
              fieldName: "chiffre_d_affaires",
              label: "Revenue",
              format: {
                digitSeparator: true,

              }
            },
            {
              type: "field",
              fieldName: "resultat_net",
              label: "Net profit",
              format: {
                digitSeparator: true,

              }
            },
            {
              type: "field",
              fieldName: "autonomie_financiere",
              label: "Financial autonomy",
              format: {
                digitSeparator: true,
                places: 2,
                round: true
              }
            },
            {
              type: "field",
              fieldName: "ratio_de_liquidite",
              label: "Cash ratio",
              format: {
                digitSeparator: true,
                places: 2,
                round: true
              }
            },
            {
                type: "button",
                fieldName: "saveButton",
                label: "Save Selection",
                width: "100px",
                action: function(event) {
                  // Code pour gérer l'action du bouton de sauvegarde
                  console.log("Button clicked");
                }
            }
          ],
        },
        container: "tableDiv",
        
      });
      
    //   // Demande l'actualisation de la couche
    //   featureLayer.refresh()
    //     .then(() => {
    //       console.log("La couche a été actualisée avec succès");
    //     })
    //     .catch((error) => {
    //       console.error("Erreur lors de l'actualisation de la couche :", error);
    //     });

    });
  }, []);

  return <div id="tableDiv" className="feature-table" style={{ height: "900px", width: "100%" }}></div>;
};

export default FeatureTableComponent;